<template>
  <div class="aside-additional-services">
    <div><label for="argos"><input id="argos" type="checkbox" v-model="argos"/><span>Ajouter le gravage et l'inscription Argos
      (recommandé par
      les assurances)</span></label></div>
    <template v-if="!isVO">
      <hr>
      <div><label for="extension"><input id="extension" type="checkbox" v-model="extension"
                                         :disabled="loadingCart"/><span>Ajouter l'Extension de
      Garantie : 12 mois
      batterie(s) incluse(s)<Spinner
          :size="14" v-if="loadingCart"/></span></label></div>
    </template>
    <hr>
    <div><label for="ce"><input id="ce" type="checkbox" v-model="ce" :disabled="loadingCart"/><span>Ajouter le Contrat d'Entretien Île De France <Spinner
      :size="14" v-if="loadingCart"/></span></label>
      <div class="ce-id" :class="{active: ce}">
        <div><label for="ce-148997"><input id="ce-148997" type="radio" value="148997" v-model="ceId"
                                           :disabled="addingCEToCart"/>1 an (199
          €)</label></div>
        <div><label for="ce-148998"><input id="ce-148998" type="radio" value="148998" v-model="ceId"
                                           :disabled="addingCEToCart"/>2 ans (299
          €)</label></div>
        <div class="ce-includes"><em>Inclus : entretien du véhicule selon les préconisations du constructeur pour
          maintenir la garantie, et remplacement des plaquettes de frein dès que nécessaire.</em></div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/icons/Spinner.vue";

export default {
  name: "AdditionalServices",
  components: {Spinner},
  data() {
    return {
      argos: false,
      extension: false,
      ce: false,
      ceId: 148998,
      lastCeCartItemKeyAdded: null,
      extensionGarantieCartItemKey: null,
      wcStoreApiNonce: '',
      loadingCart: false,
      addingCEToCart: false,
    }
  },
  computed: {
    isVO() {
      return document.body.classList.contains('occasion')
    },
  },
  methods: {
    toggleGravageCookie(value) {
      /**
       * @external Cookies
       * https://github.com/js-cookie/js-cookie
       */
      Cookies.set('gravage_argos', value ? '1' : '0')
    },
    addExtensionGarantieToCart() {
      fetch('/wp-json/wc/store/cart/add-item', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Nonce': this.wcStoreApiNonce,
        },
        body: JSON.stringify({id: 146380, quantity: 1})
      }).then(response => {
        if (response.status === 201) {
          return response.json()
        } else {
          alert("Un problème a empêché l'ajout de l'extension de garantie au panier.")
        }
      })
        .then(data => this.extensionGarantieCartItemKey = data.items[0].key)
    },
    removeExtensionGarantieFromCart() {
      fetch('/wp-json/wc/store/cart/remove-item', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Nonce': this.wcStoreApiNonce,
        },
        body: JSON.stringify({key: this.extensionGarantieCartItemKey})
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          } else {
            alert("Un problème a empêché la suppression du contrat d'entretien du panier.")
          }
        })
        .then(() => this.extensionGarantieCartItemKey = null)
    },
    addCEToCart() {
      this.addingCEToCart = true
      fetch('/wp-json/wc/store/cart/add-item', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Nonce': this.wcStoreApiNonce,
        },
        body: JSON.stringify({id: this.ceId, quantity: 1})
      }).then(response => {
        if (response.status === 201) {
          return response.json()
        } else {
          alert("Un problème a empêché l'ajout du contrat d'entretien.")
        }
      })
        .then(data => this.lastCeCartItemKeyAdded = data.items[0].key)
        .finally(() => this.addingCEToCart = false)
    },
    removeCEFromCart() {
      fetch('/wp-json/wc/store/cart/remove-item', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Nonce': this.wcStoreApiNonce,
        },
        body: JSON.stringify({key: this.lastCeCartItemKeyAdded})
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          } else {
            alert("Un problème a empêché la suppression du contrat d'entretien du panier.")
          }
        })
        .then(() => this.lastCeCartItemKeyAdded = null)
    }
  },
  beforeMount() {
    this.argos = Cookies.get('gravage_argos') === '1'
    this.$watch('argos', (val) => {
      this.toggleGravageCookie(val)
    })
    // Get WP STORE API nonce
    this.loadingCart = true
    fetch('/wp-json/wc/store/cart/')
      .then(response => {
        this.wcStoreApiNonce = response.headers.get('Nonce')
        return response.json()
      }).then(data => {
      // Check if any CE is in cart
      const item = data.items.find(item => [148997, 148998].includes(item.id))
      if (item !== undefined) {
        this.ce = data.items.some(item => [148997, 148998].includes(item.id));
        this.ceId = item.id
        this.lastCeCartItemKeyAdded = item.key
      }
      // Check if extension garantie is in cart
      this.extension = data.items.some(item => item.id === 146380)
    })
      .finally(() => {
        this.loadingCart = false
        this.$watch('ce', (val) => {
          if (val) {
            this.addCEToCart()
          } else {
            this.removeCEFromCart()
          }
        })
        this.$watch('ceId', () => {
          this.removeCEFromCart()
          this.addCEToCart()
        })
        this.$watch('extension', (val) => {
          if (val) {
            this.addExtensionGarantieToCart()
          } else {
            this.removeExtensionGarantieFromCart()
          }
        })
      })
  },
}
</script>

<style scoped lang="scss">
.aside-additional-services {
  margin-bottom: 2rem;

  label {
    display: grid;
    grid-template-columns: 25px auto;
    cursor: pointer;

    input {
      margin-top: 3px;
      $size: 16px;
      width: $size;
      height: $size;

      &[type="checkbox"] {
        accent-color: var(--yellow);
      }

      &[type="radio"] { // SAFARI FIX
        $size: 15px;
        width: $size;
        height: $size;
      }
    }

    span {
      svg {
        margin-left: 1rem;
        vertical-align: middle;
      }
    }
  }

  .ce-id {
    margin-left: 4rem;
    opacity: 0;
    transition: opacity .15s .15s ease-in-out;

    &.active {
      opacity: 1;
    }
  }

  .ce-includes {
    line-height: 1;

    em {
      font-size: smaller;
    }
  }

}

</style>
